<template>
  <tr>
    <td class="pr-3">
      <template v-if="editing">
        <input type="text"
               class="styled-input form-control"
               :class="errors.includes('name') ? 'field-invalid error border-danger': ''"
               v-model="child.name">
      </template>
      <template v-else>
        {{child.name}}
      </template>
    </td>
    <td>
      <template v-if="editing">
        <select type="text" class="styled-input form-control"
                :class="errors.includes('gender') ? 'field-invalid error border-danger': ''" v-model="child.gender">
          <option value="m">{{$t('message.male')}}</option>
          <option value="f">{{$t('message.female')}}</option>
          <option value="x">{{$t('message.other')}}</option>
        </select>
      </template>
      <template v-else>
        {{fullGender(child.gender)}}
      </template>

    </td>
    <td>
      <!--      {{child.birthdate}}-->
      <template v-if="editing">
        <span
          style="border:1px solid transparent; border-radius:3px; margin-bottom:10px;"
          class="d-block"
          :class="errors.includes('birthdate')? 'field-invalid error border-danger ': ''">
           <input type="date" class="mb-0 birthdate styled-input form-control"
                   v-model="child.birthdate">
        </span>

      </template>
      <template v-else>
        {{child.birthdate ? calcAge(child.birthdate) : ''}}
      </template>
    </td>
    <td class="child-actions pos-rel">
      <!--      {{child.editing}}-->
      <button type="button"
              v-if="!editing"
              @click.prevent.stop="openForm"
              class="btn-link btn p-0 pr-2">
        <i class="fas fa-edit"></i>
      </button>
      <button type="button"
              v-if="editing"
              @click.prevent.stop="saveChild"
              class="btn-link btn p-0 pr-2">
        <i class="fas fa-check"></i>
      </button>
      <button type="button"
              v-if="editing"
              @click.prevent.stop="deleteChild"
              class="btn-link btn p-0 pr-2">
        <i class="fas fa-trash-alt"></i>
      </button>
    </td>
  </tr>
</template>
<script>
  export default {
    data() {
      return {
        editing: !this.child.name,
        errors: []
      }
    },
    methods: {
      saveChild() {
        const valid = this.isChildValid();
       // console.log(valid)
        if (valid) {
          this.closeForm()
        }
      },
      deleteChild() {
        this.$emit('deleteChild', this.index);
        this.closeForm()
      },
      openForm() {
        this.editing = true
      },
      isChildValid() {
        this.errors = [];
        let requiredFields = [
          'name',
          'gender',
          'birthdate',
        ];
        let valid = true;
        requiredFields.forEach(field => {
          if (!this.child[field]) {
            valid = false;
            this.errors.push(field)
          }
        });
       // console.log('validating', valid)
        return valid
      },
      closeForm() {

        this.editing = false;
        const el = this.$el.querySelector('.birthdate');
        el._flatpickr.destroy()


      }
    },
    props: {
      index: {
        type: Number,
        default() {
          return 0
        }
      },
      child: {
        type: Object,
        default() {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Users/Child.vue